// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__uJbFT","list":"PatternAutocomplete_list__3LPgC"};